// extracted by mini-css-extract-plugin
export default {"main":"AreaGerencial_main__LH6mx","svg":"AreaGerencial_svg__S8mlJ","svgReverse":"AreaGerencial_svgReverse__CQk1o","toggleButton":"AreaGerencial_toggleButton__iE38d"};